"use client"

import * as React from "react"
import { MoonIcon, SunIcon } from "lucide-react"
import { useTheme } from "@/components/app/theme-provider"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useTranslation } from "@/components/app/i18n-provider"

export function ThemeToggle() {
    const { theme, setTheme } = useTheme()
    const { t } = useTranslation()

    return (
        <DropdownMenu>
            <DropdownMenuTrigger render={<Button variant="outline" size="icon" />}>
                <SunIcon className="size-4 scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
                <MoonIcon className="absolute size-4 scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
                <span className="sr-only">{t("theme.toggle")}</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem
                    className={cn(theme === "light" && "bg-accent text-accent-foreground")}
                    onClick={() => setTheme("light")}
                >
                    {t("theme.light")}
                </DropdownMenuItem>
                <DropdownMenuItem
                    className={cn(theme === "dark" && "bg-accent text-accent-foreground")}
                    onClick={() => setTheme("dark")}
                >
                    {t("theme.dark")}
                </DropdownMenuItem>
                <DropdownMenuItem
                    className={cn(theme === "system" && "bg-accent text-accent-foreground")}
                    onClick={() => setTheme("system")}
                >
                    {t("theme.system")}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
